import QuicklyGenerateInsuranceVideoCommitmentModal from './quickly-generate-insurance-video-commitment-modal.vue'
export default QuicklyGenerateInsuranceVideoCommitmentModal
